import Vue from 'vue'
import Step from './Step'
import Steps from './Steps'

Vue.component('ui-steps', Steps)
Vue.component('ui-step', Step)
